
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/glossary/[slug]",
      function () {
        return require("private-next-pages/glossary/[slug]/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/glossary/[slug]"])
      });
    }
  